module.exports = __webpack_public_path__ + "img/logo.774f12a9.png";